import { StoreModule } from '@ngrx/store';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LobbyComponent } from './lobby.component';

const routes: Routes = [
  { path: 'lobby-view', component: LobbyComponent },
  { path: 'lobby-central-view', loadChildren: () => import('./lobby-central-views/lobby-central-views.module').then(m => m.LobbyCentralViewsModule) }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LobbyRoutingModule { }
